import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { Equipment } from './Equipment';
import { LocationAndPremises } from './LocationAndPremises';
import { OtherAssets } from './OtherAssets';
import { ProductDescription } from './ProductDescription';
import { Production } from './Production';
import { TechProcess } from './TechProcess';
import { Uniqueness } from './Uniqueness';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.LOCATION_AND_PREMISES]: LocationAndPremises,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.EQUIPMENT]: Equipment,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.ASSETS]: OtherAssets,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.TECHNOLOGICAL_PROCESS]: TechProcess,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.PRODUCTION]: Production,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.PRODUCT_DESCRIPTION]: ProductDescription,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.UNIQUENESS]: Uniqueness,
};

export const BusinessOperations: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
